class CartUpsellElement extends HTMLElement {
  constructor() {
    super();
    this.addedUpsellProducts = window.addedUpsellProducts || [];
    window.addedUpsellProducts = this.addedUpsellProducts;
    this.cartObserver = null;
    this.initialized = false;
  }

  connectedCallback() {
    if (!this.initialized) {
      this.init();
      this.initialized = true;
    }
  }

  disconnectedCallback() {
    this.cleanup();
  }

  async init() {
    await this.syncAddedProductsWithCart();
    this.initializeCartUpsell();
    this.setupCartChangeListeners();
  }

  cleanup() {
    if (this.cartObserver) {
      this.cartObserver.disconnect();
    }
    // Remove event listeners
    document.removeEventListener('cart:updated', this.handleCartUpdate);
    document.removeEventListener('cart:refresh', this.handleCartRefresh);
    document.removeEventListener('DiscountUpdateEvent', this.handleDiscountUpdate);
  }

  setupCartChangeListeners() {
    this.handleCartUpdate = () => {
      setTimeout(() => {
        this.syncAddedProductsWithCart();
        this.initializeCartUpsell();
      }, 300);
    };

    this.handleCartRefresh = () => {
      setTimeout(() => {
        this.syncAddedProductsWithCart();
        this.initializeCartUpsell();
      }, 300);
    };

    this.handleDiscountUpdate = () => {
      setTimeout(() => {
        this.syncAddedProductsWithCart();
        this.initializeCartUpsell();
      }, 300);
    };

    document.addEventListener('cart:updated', this.handleCartUpdate);
    document.addEventListener('cart:refresh', this.handleCartRefresh);
    document.addEventListener('DiscountUpdateEvent', this.handleDiscountUpdate);

    this.cartObserver = new MutationObserver((mutations) => {
      let shouldReinit = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (node.querySelector && node.querySelector('.cart-upsell'))) {
              shouldReinit = true;
            }
          });
        }
      });

      if (shouldReinit) {
        setTimeout(() => {
          this.syncAddedProductsWithCart();
          this.initializeCartUpsell();
        }, 100);
      }
    });

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      this.cartObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
  }

  async syncAddedProductsWithCart() {
    try {
      console.log("start!!!!!!!!!!!!!!!!!");
      const response = await fetch('/cart.js');

      if (response.ok) {
        console.log("~~~~~~~~~~~~");
        const cart = await response.json();
        const cartProductIds = cart.items.map(item => item.product_id.toString());

        // Get all available upsell product IDs from this element
        const allUpsellProducts = this.querySelectorAll('.cart-upsell__product');
        const allUpsellProductIds = Array.from(allUpsellProducts).map(el => el.dataset.productId);

        // Clear the added products list first
        const previouslyAdded = [...this.addedUpsellProducts];
        this.addedUpsellProducts = [];

        // Add back only products that are still in cart AND are upsell products
        allUpsellProductIds.forEach(productId => {
          if (cartProductIds.includes(productId)) {
            this.addedUpsellProducts.push(productId);
          }
        });

        // Reset all product elements to visible state first
        allUpsellProducts.forEach(productElement => {
          const productId = productElement.dataset.productId;
          const button = productElement.querySelector('.cart-upsell__add-btn');

          if (!this.addedUpsellProducts.includes(productId)) {
            // This product is not in cart, so make it available
            productElement.style.display = '';
            productElement.style.opacity = '';
            productElement.style.pointerEvents = '';

            if (button) {
              button.removeAttribute('data-initialized');
              button.classList.remove('loading', 'success');
              button.disabled = false;
            }
          }
        });

        // Check if upsell container exists, if not and we have products to show, reload the section
        const hasProductsToShow = allUpsellProductIds.some(id => !this.addedUpsellProducts.includes(id));

        if (!this.isConnected && hasProductsToShow) {
          // Force a cart refresh to get the upsell section back
          const cartItemsComponent = document.querySelector('cart-items-component');
          if (cartItemsComponent) {
            const sectionId = cartItemsComponent.dataset.sectionId;
            if (sectionId) {
              const sectionsResponse = await fetch(`${window.location.origin}/?section_id=${sectionId}`);
              if (sectionsResponse.ok) {
                const newHTML = await sectionsResponse.text();
                const parser = new DOMParser();
                const newDoc = parser.parseFromString(newHTML, 'text/html');
                const newUpsell = newDoc.querySelector('cart-upsell');

                if (newUpsell) {
                  // Find where to insert the upsell
                  const cartSummary = document.querySelector('.cart-drawer__summary');
                  if (cartSummary) {
                    cartSummary.insertAdjacentElement('beforebegin', newUpsell);
                  }
                }
              }
            }
          }
        }

        console.log('Sync complete. Added products:', this.addedUpsellProducts);
        // Update global reference
        window.addedUpsellProducts = this.addedUpsellProducts;
      }
    } catch (error) {
      console.error('Error syncing cart products:', error);
    }
  }

  initializeCartUpsell() {
    // First sync state
    const allProducts = this.querySelectorAll('.cart-upsell__product');

    // Hide products that are in the addedUpsellProducts list
    allProducts.forEach(productElement => {
      const productId = productElement.dataset.productId;
      if (this.addedUpsellProducts.includes(productId)) {
        productElement.style.display = 'none';
      } else {
        productElement.style.display = '';
      }
    });

    // Check if all products are hidden and remove container if so
    const visibleProducts = this.querySelectorAll('.cart-upsell__product:not([style*="display: none"])');
    if (visibleProducts.length === 0) {
      this.remove();
      return;
    }

    // Initialize buttons only for visible products
    const upsellButtons = this.querySelectorAll('.cart-upsell__add-btn');

    console.log(upsellButtons, "upsellButtons");
    upsellButtons.forEach((button) => {
      const productElement = button.closest('.cart-upsell__product');
      const productId = productElement?.dataset?.productId;

      // Remove old event listeners by cloning the button
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      // Reset button state
      newButton.classList.remove('loading', 'success');
      newButton.disabled = false;

      newButton.addEventListener('click', (e) => this.handleAddToCart(e, newButton));
    });
  }

  async handleAddToCart(e, button) {
    console.log("test");
    e.preventDefault();
    e.stopPropagation();

    const variantId = button.dataset.variantId;
    const productTitle = button.dataset.productTitle;

    if (!variantId || button.disabled) {
      return;
    }

    // Store which product was added
    const productElement = button.closest('.cart-upsell__product');
    const addedProductId = productElement?.dataset?.productId;

    if (!this.addedUpsellProducts.includes(addedProductId)) {
      this.addedUpsellProducts.push(addedProductId);
      window.addedUpsellProducts = this.addedUpsellProducts;
    }

    // Add loading state
    button.classList.add('loading');
    button.disabled = true;

    // Add visual feedback
    productElement.style.opacity = '0.5';
    productElement.style.pointerEvents = 'none';

    try {
      const response = await fetch(window.Shopify?.routes?.root + 'cart/add.js' || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      if (response.ok) {
        const cartData = await response.json();

        // Success state
        button.classList.remove('loading');
        button.classList.add('success');

        // Hide the product immediately
        productElement.style.display = 'none';

        // Check if this was the last visible product
        const remainingVisibleProducts = this.querySelectorAll('.cart-upsell__product:not([style*="display: none"])');

        if (remainingVisibleProducts.length === 0) {
          // Remove the entire upsell container
          this.style.animation = 'fadeOut 0.3s ease forwards';
          setTimeout(() => {
            this.remove();
          }, 300);
        }

        // Update cart with special handling for upsell section
        await this.updateCartDisplay(remainingVisibleProducts, cartData);

      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to add to cart');
      }

    } catch (error) {
      console.error('Error adding to cart:', error);

      // Reset button state
      button.classList.remove('loading');
      button.disabled = false;
      productElement.style.opacity = '1';
      productElement.style.pointerEvents = 'auto';

      // Remove from added products list since it failed
      const index = this.addedUpsellProducts.indexOf(addedProductId);
      if (index > -1) {
        this.addedUpsellProducts.splice(index, 1);
        window.addedUpsellProducts = this.addedUpsellProducts;
      }

      alert(`Sorry, there was an error adding ${productTitle} to your cart. Please try again.`);
    }
  }

  async updateCartDisplay(remainingVisibleProducts, cartData) {
    try {
      const cartItemsComponent = document.querySelector('cart-items-component');
      const sectionId = cartItemsComponent?.dataset?.sectionId;

      if (sectionId) {
        // Request the section update with both cart items and summary
        const sectionsResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            sections: [sectionId]
          })
        });

        if (sectionsResponse.ok) {
          const sectionsData = await sectionsResponse.json();

          if (sectionsData.sections && sectionsData.sections[sectionId]) {
            const newHTML = sectionsData.sections[sectionId];
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(newHTML, 'text/html');
            const newCartItems = newDoc.querySelector('cart-items-component');

            if (newCartItems && cartItemsComponent) {
              // Remove upsell from the new HTML before updating
              const newUpsell = newCartItems.querySelector('cart-upsell');
              if (newUpsell) {
                newUpsell.remove();
              }

              // Update cart items
              const cartItemsOnly = cartItemsComponent.querySelector('.cart-items');
              const newCartItemsOnly = newCartItems.querySelector('.cart-items');

              if (cartItemsOnly && newCartItemsOnly) {
                cartItemsOnly.innerHTML = newCartItemsOnly.innerHTML;
              }

              // CRITICAL FIX: Update the cart summary section with all calculated totals
              const currentSummary = document.querySelector('.cart__summary-totals');
              const newSummary = newDoc.querySelector('.cart__summary-totals');
              
              if (currentSummary && newSummary) {
                // Update the entire summary section to get correct totals, shipping, etc.
                currentSummary.innerHTML = newSummary.innerHTML;
              }

              // Also update the checkout button section which contains the final total
              const currentCtas = document.querySelector('.cart__ctas');
              const newCtas = newDoc.querySelector('.cart__ctas');
              
              if (currentCtas && newCtas) {
                currentCtas.innerHTML = newCtas.innerHTML;
              }

              // Update any other cart elements except upsell
              const otherElements = newCartItems.querySelectorAll(':scope > *:not(.cart-items):not(cart-upsell):not(.cart__summary-totals):not(.cart__ctas)');
              otherElements.forEach(element => {
                const existingElement = cartItemsComponent.querySelector(`:scope > .${element.className}`);
                if (existingElement && !element.tagName.toLowerCase().includes('cart-upsell')) {
                  existingElement.innerHTML = element.innerHTML;
                }
              });
            }
          }
        }
      }

      // Update cart bubble
      await this.updateCartBubble();

      // Trigger events
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      document.dispatchEvent(new CustomEvent('CartAddEvent', { detail: cartData }));

    } catch (updateError) {
      console.error('Cart update error:', updateError);
      // Fallback: reload the page
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }

  async updateCartBubble() {
    const cartBubble = document.querySelector('.cart-bubble');
    const cartBubbleText = document.querySelector('.cart-bubble__text-count');
    if (cartBubble && cartBubbleText) {
      const cartResponse = await fetch('/cart.js');
      if (cartResponse.ok) {
        const currentCart = await cartResponse.json();
        cartBubbleText.textContent = currentCart.item_count;

        if (currentCart.item_count > 0) {
          cartBubble.classList.remove('visually-hidden');
        }
      }
    }
  }

  async updateCartTotals() {
    // This method is no longer needed as we update the entire summary section
    // Kept for backward compatibility if called elsewhere
    const cartTotal = document.querySelector('[ref="cartTotal"]');
    if (cartTotal) {
      const cartResponse = await fetch('/cart.js');
      if (cartResponse.ok) {
        const currentCart = await cartResponse.json();
        const totalPrice = new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: 'EUR'
        }).format(currentCart.total_price / 100);
        cartTotal.textContent = totalPrice;
      }
    }
  }

  // Public method to reinitialize if needed
  reinitialize() {
    this.syncAddedProductsWithCart().then(() => {
      this.initializeCartUpsell();
    });
  }
}

// Register the custom element
customElements.define('cart-upsell', CartUpsellElement);

// Initialize existing elements if DOM is already loaded
if (document.readyState !== 'loading') {
  // Auto-initialize any existing cart-upsell elements
  document.querySelectorAll('cart-upsell').forEach(element => {
    if (!element.initialized) {
      element.init();
    }
  });
} else {
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('cart-upsell').forEach(element => {
      if (!element.initialized) {
        element.init();
      }
    });
  });
}